import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2, Search } from 'lucide-react';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文 (Mandarin)' },
  { code: 'pt', label: 'Português' },
  { code: 'es', label: 'Español' },
  { code: 'hi', label: 'हिन्दी (Hindi)' },
];

export const SearchForm = ({ onSearch, isLoading }) => {
  const { t, i18n } = useTranslation();
  const [query, setQuery] = useState('');
  const [language, setLanguage] = useState(i18n.language || 'en');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query, language);
    }
  };

  const handleLanguageChange = (val) => {
      setLanguage(val);
      i18n.changeLanguage(val);
  }

  return (
    <div className="bg-white dark:bg-gray-900 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 transition-colors duration-300">
        <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
                <Input
                    type="text"
                    placeholder={t('search_placeholder')}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    disabled={isLoading}
                    className="h-12 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-primary focus:ring-primary/20 text-lg placeholder:text-gray-400 dark:placeholder:text-gray-500"
                />
            </div>
            
            <Select value={language} onValueChange={handleLanguageChange} disabled={isLoading}>
                <SelectTrigger className="w-full md:w-[180px] h-12 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100">
                    <SelectValue placeholder="Language" />
                </SelectTrigger>
                <SelectContent className="dark:bg-gray-900 dark:border-gray-800 dark:text-gray-100 max-h-[300px]">
                    {LANGUAGES.map((lang) => (
                        <SelectItem key={lang.code} value={lang.code} className="cursor-pointer">
                            {lang.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Button
                type="submit"
                disabled={isLoading || !query.trim()}
                className="h-12 px-8 bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg shadow-sm transition-all"
            >
                {isLoading ? (
                    <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> {t('loading')}</>
                ) : (
                    <><Search className="mr-2 h-4 w-4" /> {t('search_button')}</>
                )}
            </Button>
        </form>
    </div>
  );
};
